<img
    class="logo"
    alt="Radar Online"
    loading="lazy"
    height="169" width="610"
    src="https://cdn.ciphersports.io/images/radar-sports/radar-logo.png"
>
<h2 class="header-text">
    Daily, Celebrity News As It Happens
</h2>
<div class="subhead-text">
    Don't miss a thing. Radar Online is your #1 source for breaking news.
</div>
<a
    class="link-button"
    href="https://www.radaronline.com" target="_blank"
>
    Go to Radar Online
</a>